import { AlertConfirm } from "components/WebDesigner/ConfirmationPopups";
import { useState, useEffect, Fragment } from "react";
import ReactDOM from "react-dom";
import Loader from "vagaro-website-rendering/src/components/Common/Loader";
import VGPopUp from "vagaro-website-rendering/src/components/Controls/VGPopUp";
import CustomMultiSelect from "vagaro-website-rendering/src/components/CustomMultiSelect";
import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { AddSetItem, EditSetItemCategories, GetAllBusinessTypes, GetSetCategories, SetType } from "./SetLibraryAPI";
import { OpenSetCategoryPopup } from "./SetCategoryPopUp";
import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext";
import { CheckItem } from "components/WebDesigner/StyleInputs/CategorySelector";
import { UploadImage } from "components/WebDesigner/Utilities/FileUploadUtility";
import Toast from "components/WebDesigner/Toast";


export enum SetSaveType {
    Create = 0,
    EditContent = 1,
    EditCategories = 2
}

export function SaveSetMenu({content,setType,userContext,onDismiss,editId,saveType,inCategories,onUpdateCategories}:{content:string[],setType:SetType,userContext:UserContext,onDismiss:()=>void,editId?:string,saveType:SetSaveType,inCategories?:string[],onUpdateCategories?:()=>void}){

    const [categories,setCategories] = useState<any[]>([]);
    const [selectedCategories,setSelectedCategories] = useState<string[]>(inCategories??[]);
    const [options,setOptions] = useState<{label:string,value:string}[]>([]);
    const [isLoading,setIsloading] = useState(true);


    useEffect(()=>{
        let dom = document.getElementById("save-section-btn");
        (dom as HTMLButtonElement).disabled = true;



        GetSetCategories(userContext,setType,(data:any)=>{

            
        

            let options = data.data.data.map((item:any)=>{return {label:item.name,value:item.id}});

            setOptions(options);
            setCategories(data.data.data);

           setIsloading(false);
        },
        (error:any)=>{
            console.error(error);
            AlertConfirm("Error loading categories");
            setIsloading(false);
        }
        
        );
        //eslint-disable-next-line
    },[]);


    const TrySave = ()=>{

        if(selectedCategories.length==0){
            AlertConfirm("Please select at least one category");
            return;
        }
       
        setIsloading(true);

        if( saveType===SetSaveType.Create){

           
            AddSetItem(userContext,setType,content,selectedCategories,
            (data:any)=>{
                setIsloading(false);
                if(onUpdateCategories){
                    onUpdateCategories();
                }



                Toast("Set saved successfully")
                onDismiss();
                
            },
            (error:any)=>{
                setIsloading(false);
                AlertConfirm("Error saving set, please try again");
            });
            }
        else if(saveType === SetSaveType.EditCategories && editId){ // save only categories

            
            EditSetItemCategories(userContext,setType,editId,selectedCategories,()=>{



                setIsloading(false);
                if(onUpdateCategories){
                    onUpdateCategories();
                }
                Toast("Set updated successfully");
                onDismiss();
            },()=>{
                setIsloading(false);
                AlertConfirm("Error updating set, please try again");

            });
            // UpdateCategoriesForSection(siteData.userContext,editId,selectedCategories,        
            // (data:any)=>{
            //     setIsloading(false);
            //     if(onUpdateCategories){
            //         onUpdateCategories();
            //     }
     
            //     onDismiss();
            // },
            // (error:any)=>{
            //     setIsloading(false);
            //     AlertConfirm("Error updating section, please try again");
            // });

        }

        else if(saveType === SetSaveType.EditContent && editId){ // save both content & categories
            // EditSection(siteData.userContext,editId,selectedCategories,content,
            //     (data:any)=>{
            //         UpdateCategoriesForSection(siteData.userContext,editId,selectedCategories,        
            //             (data:any)=>{
            //                 setIsloading(false);
            //                 if(onUpdateCategories){
            //                     onUpdateCategories();
            //                 }
            //                 AlertConfirm("Section updated successfully","save-success","Success");
            //                 onDismiss();
            //             },
            //             (error:any)=>{
            //                 setIsloading(false);
            //                 AlertConfirm("Error updating section, please try again");
            //             });

            //     },
            //     (error:any)=>{
            //         setIsloading(false);
            //         AlertConfirm("Error updating section, please try again");
            //     });
        }
    }

    return <>
    {/* {isLoading && <Loader/>} */}

    <div style={{fontSize:"16px",lineHeight:"20px",paddingBottom:"4px",fontWeight:"600"}}>Section Category:</div>
  
    <div style={{position:"fixed",width:"456px",zIndex:"10"}}>
          <style>
            {`
            .multi-select-option { padding-top:12px !important; padding-bottom:12px !important;
            `}
        </style>
        { 
    <CustomMultiSelect
        startOpen={false}
        options={options}
        key={options.length + (isLoading?"loading":"loaded")}
        placeholder="Select Category"
        useDualHeader={true}
        defaultValues={selectedCategories}
        onChange={(value:string[])=>{
            setSelectedCategories(value);
            let dom = document.getElementById("save-section-btn");
            (dom as HTMLButtonElement).disabled = value.length==0;
        
        }}
        
        footer={<button 
            onClick={(e) => {
                onDismiss();
                console.log("open category popup",selectedCategories);
                OpenSetCategoryPopup(userContext,setType,categories,content, onUpdateCategories,()=>{

                    if(setType!= SetType.Image)
                    OpenSavSetMenu(setType,content,userContext,editId,saveType,inCategories,onUpdateCategories);
                    else
                    OpenSaveImageMenu(content,userContext,editId,saveType,inCategories,onUpdateCategories);


                });
                // OpenSectionCategoryPopup(siteData,categories,content,onUpdateCategories,()=>{
                //     OpenSaveAsSectionMenu(content,siteData,editId,saveType,inCategories,onUpdateCategories);//reopen with same settings when closing the category popup
                // });

            }}  
            className="invisible-button bold  bg-w gray-hover" style={{textAlign:"left",background:"white",padding:"12px 16px",marginBottom:"-8px",position:"sticky",bottom:"-8px"}}
            ><b>+</b> Edit Categories</button>}
        />
}
    </div>
    <div style={{height:"30px"}} ></div>
    <div className="flex-row justify-end gap-med" style={{padding:"24px 6px 6px 0px"}}>
    <button className="w-button w-button-secondary" onClick={(e) => { onDismiss();}}>Cancel</button>
        <button disabled={selectedCategories.length<=0} style={(selectedCategories.length<=0?{opacity:".5",pointerEvents:"none"}:{})} id="save-section-btn" className="w-button w-button-primary" onClick={(e) => { TrySave()}}>Save</button>
    </div>
    </>

}

export function SaveImageMenu({content,userContext,onDismiss,editId,saveType,inCategories,onUpdateCategories}:{content:string[],userContext:UserContext,onDismiss:()=>void,editId?:string,saveType:SetSaveType,inCategories?:string[],onUpdateCategories?:()=>void}){


    const [selectedCategories,setSelectedCategories] = useState<string[]>(inCategories??[]);
    // const [options,setOptions] = useState<{label:string,value:string}[]>([]);
    const [isLoading,setIsloading] = useState(true);

    const [mainCategories,setMainCategories] = useState<any[]>([]);
    const [subCategories,setSubCategories] = useState<any[]>([]);

    const setType = SetType.Image;

    useEffect(()=>{


        GetAllBusinessTypes(userContext,(data:any)=>{

            let list = data?.data?.data??[];

            const mainCats = [];
            const subCats = [];

            for(let i = 0;i<list.length;i++){

                let item = list[i];
                if(item.parentCategoryId){
                  
                    subCats.push(item);
                }
                else{
                    mainCats.push(item);
                }
            }
            

            

     
            setMainCategories(mainCats);
            setSubCategories(subCats);

           setIsloading(false);
        },
        (error:any)=>{
            console.error(error);
            AlertConfirm("Error loading categories");
            setIsloading(false);
        }
        
        );
        //eslint-disable-next-line
    },[]);

    function sleep(ms:number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    const  TrySave = async ()=>{


        if(selectedCategories.length==0){
            AlertConfirm("Please select at least one category");
            return;
        }
       
        setIsloading(true);

        if( saveType===SetSaveType.Create){
       
            let urls = [...content];

            for(let i = 0;i<urls.length;i++){
                let url = urls[i];
       

                if(!url.includes("data:image")) // does not need to be uploaded
                    continue;

                let split = url.split("base64,");

                if(split.length<2){
                    continue; // invalid url
                }

                let base64 = split[1];

                await UploadImage(userContext,"library-image-"+i+".png",base64,(data:any)=>{ 
                    console.log("recieved",data);
                    urls[i] = userContext.cdnURL+"/WB/sets/"+data;
                    //urls[i] = data.data.data.url;

                },(error:any)=>{console.error(error);});

                await sleep(500); // sleep for 500ms to avoid collisions on CDN


            }
            

           
            AddSetItem(userContext,setType,urls,selectedCategories,
            (data:any)=>{
                setIsloading(false);
                if(onUpdateCategories){
                    onUpdateCategories();
                }



                Toast("Set saved successfully");
                onDismiss();
                
            },
            (error:any)=>{
                setIsloading(false);
                AlertConfirm("Error saving set, please try again");
            });
            }
        else if(saveType === SetSaveType.EditCategories && editId){ // save only categories

            
            EditSetItemCategories(userContext,setType,editId,selectedCategories,()=>{



                setIsloading(false);
                if(onUpdateCategories){
                    onUpdateCategories();
                }
                Toast("Set updated successfully");
                onDismiss();
            },()=>{
                setIsloading(false);
                AlertConfirm("Error updating set, please try again");

            });
  

        }

        else if(saveType === SetSaveType.EditContent && editId){ // save both content & categories
       
        }
    }

    return <>
    {isLoading && <Loader/>}
    <div className="flex-column" style={{minHeight:(isLoading?"800px":"400px")}} >
    <div style={{fontSize:"16px",lineHeight:"20px",paddingBottom:"20px",color:"#6D6E6F",fontWeight:"400"}}>Select which industries to save this image set to</div>
    {
        mainCategories.map((item:any,index:number)=>{

            return <Fragment key={index}> <div className="flex-row align-start">
                <div className="cat-heading h-full flex-column " style={{width:"200px",fontWeight:"bold",fontSize:"20px",padding:"16px 0 0 8px",}}>{item.name}</div>
                <div className="flex-row flex-wrap " style={{flex:"1",padding:"8px 0px",}}>
                    {
                        subCategories.filter((subItem:any)=>subItem.parentCategoryId === item.id).map((subItem:any,i:number)=>{

                            const onToggle = ()=>{
                                let isChecked = !selectedCategories.includes(subItem.id);
                                if(isChecked){
                                    setSelectedCategories([...selectedCategories,subItem.id]);
                                }
                                else{
                                    setSelectedCategories(selectedCategories.filter((id)=>id!==subItem.id));
                                }
                            }

                            return <div className="business-type-check flex-row gap-med align-center" key={i} >

                                <CheckItem item={subItem.name}  styling={{fontWeight:500,padding:"8px 0px",fontSize:"16px",gap:"12px"}}checked={selectedCategories.includes(subItem.id)} onClickFunc={()=>{onToggle()}}/>
                                
                 
                             
                            </div>
                        })
                    }

            </div>
            </div>
            {index<mainCategories.length-1&&<hr/>}
            </Fragment>  
            })
    }

    <div style={{height:"30px"}} ></div>

    </div>
    <div className="flex-row justify-end gap-med" style={{padding:"24px 6px 6px 0px",position:"sticky",bottom:"0",background:"white",marginBottom:"-12px",marginRight:"-12px"}}>
    <button className="w-button w-button-secondary" onClick={(e) => { onDismiss();}}>Cancel</button>

   <button disabled={selectedCategories.length<=0 } style={(selectedCategories.length<=0?{opacity:".5",pointerEvents:"none"}:{})}  className="w-button w-button-primary" onClick={(e) => {  TrySave()}}>Save</button>
    </div>
    </>

}

export function OpenSaveImageMenu(content:string[],userContext:UserContext,editId?:string,saveType?:SetSaveType,inCategories?:string[],onUpdateCategories?:()=>void,srcNode?:LayoutNode){


 
    const dom =  document.getElementById("OpenDialog1");
   
    const PopupClose = ()=>{

        if(dom){
            ReactDOM.unmountComponentAtNode(dom);
        }
    }

    let title = (saveType === SetSaveType.Create)?"Save ":"Edit ";

    title  += "Image Set";

    ReactDOM.render(
        <>
        <VGPopUp
          id={"save-image-set-popup"}
          show={true}
          onHide={PopupClose}
          title={title}
          dialogClassName="block-edit"
          body={
            <div className="alertContent">
                <SaveImageMenu  editId={editId} saveType={saveType ?? SetSaveType.Create} content={content} userContext={userContext} onDismiss={PopupClose} inCategories={inCategories} onUpdateCategories={onUpdateCategories} />
            </div>
          }
          footer={""}
          isRemoveTabModalIndex={false}
          isShowFooter={false}
          size={"modal-sm"}
          backdrop={true}
        />
  
        </>,
        dom);
}

export function OpenSavSetMenu(setType:SetType,content:string[],userContext:UserContext,editId?:string,saveType?:SetSaveType,inCategories?:string[],onUpdateCategories?:()=>void,srcNode?:LayoutNode){

    if(setType == SetType.Image){
        OpenSaveImageMenu(content,userContext,editId,saveType,inCategories,onUpdateCategories,srcNode);
        return;
    }

 
    const dom =  document.getElementById("OpenDialog1");
   
    const PopupClose = ()=>{

        if(dom){
            ReactDOM.unmountComponentAtNode(dom);
        }
    }

    let title = (saveType === SetSaveType.Create)?"Save ":"Edit ";

    title  += setType === SetType.Color?"Color Set":"Font Pair";

    ReactDOM.render(
        <>
        <VGPopUp
          id={"save-set-popup"}
          show={true}
          onHide={PopupClose}
          title={title}
          dialogClassName="block-edit"
          body={
            <div className="alertContent">
                <SaveSetMenu  editId={editId} saveType={saveType ?? SetSaveType.Create} content={content} userContext={userContext} onDismiss={PopupClose} inCategories={inCategories} onUpdateCategories={onUpdateCategories} setType={setType}/>
            </div>
          }
          footer={
            <Fragment>
             

            </Fragment >
          }
          isRemoveTabModalIndex={false}
          isShowFooter={false}
          size={"modal-sm"}
          backdrop={true}
        />
  
        </>,
        dom);

}


